import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import { IoHelpCircleOutline, IoLogOutOutline, IoSettingsOutline } from 'react-icons/io5';

import Avator from 'components/Avator';
import Menu, { MenuItem, MenuItemIcon, MenuList } from 'components/Menu';
import useProfile from './hooks/useProfile';

const ProfileInfo = styled.div`
  display: flex;
  gap: 12px;
`;

const Name = styled.span`
  display: block;
  font-weight: 500;
`;

const Email = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.global.lightTextColor};
`;

const Profile = () => {
  const { userName, userEmail, handleLogoutClick } = useProfile();

  return (
    <Menu trigger={<Avator size={40} />} minWidth={300}>
      <MenuList>
        <MenuItem disabled padding="12px 18px">
          <ProfileInfo>
            <Avator size={46} />
            <div>
              <Name>{userName}</Name>
              <Email>{userEmail}</Email>
            </div>
          </ProfileInfo>
        </MenuItem>
      </MenuList>
      <MenuList>
        <MenuItem padding="12px 18px">
          <Link to="/setting/account">
            <MenuItemIcon>
              <IoSettingsOutline />
            </MenuItemIcon>
            <span>계정 설정</span>
          </Link>
        </MenuItem>
        <MenuItem padding="12px 18px">
          <a href={`${process.env.REACT_APP_WEB_URL}/help`} target="_blank" rel="noreferrer">
            <MenuItemIcon>
              <IoHelpCircleOutline />
            </MenuItemIcon>
            <span>고객센터</span>
          </a>
        </MenuItem>
      </MenuList>
      <MenuList>
        <MenuItem padding="12px 18px">
          <button onClick={handleLogoutClick}>
            <MenuItemIcon>
              <IoLogOutOutline />
            </MenuItemIcon>
            <span>로그아웃</span>
          </button>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default Profile;
